import Post, {IPost} from '@/models/Post'

export interface ILife extends IPost {
}

export default class Life extends Post {
  constructor(defaults?: ILife) {
    super(defaults)
    if (defaults) {
    }
  }

  get className(): string {
    return Life.name
  }
}
